// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProcedureAlertId } from './FermentationProcedureAlert';
import { fermentationAttributeDefinitionId } from './FermentationAttributeDefinition';
import { z } from 'zod';
export const fermentationProcedureAlertSignalId = (z.number());
export const fermentationProcedureAlertSignal = z.object({
    id: fermentationProcedureAlertSignalId,
    procedure_alert_id: fermentationProcedureAlertId,
    attribute_id: fermentationAttributeDefinitionId,
    created_at: z.date(),
});
export const fermentationProcedureAlertSignalInitializer = z.object({
    id: fermentationProcedureAlertSignalId.optional(),
    procedure_alert_id: fermentationProcedureAlertId,
    attribute_id: fermentationAttributeDefinitionId,
    created_at: z.date().optional(),
});
export const fermentationProcedureAlertSignalMutator = z.object({
    id: fermentationProcedureAlertSignalId.optional(),
    procedure_alert_id: fermentationProcedureAlertId.optional(),
    attribute_id: fermentationAttributeDefinitionId.optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=FermentationProcedureAlertSignal.js.map